"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentActions = void 0;
exports.paymentActions = [
    // Payment management routes
    {
        name: 'payment.list',
        path: '/list',
        method: 'GET'
    },
    {
        name: 'payment.index',
        path: '/index',
        method: 'GET'
    },
    {
        name: 'payment.create',
        path: '/create',
        method: 'POST'
    },
    {
        name: 'payment.status',
        path: '/status/:id',
        method: 'GET'
    },
    {
        name: 'payment.test',
        path: '/test',
        method: 'GET'
    },
    {
        name: 'payment.downgrade',
        path: '/downgrade',
        method: 'POST'
    },
    // Stripe specific routes
    {
        name: 'payment.stripe.confirm',
        path: '/stripe/confirm',
        method: 'POST'
    },
    {
        name: 'payment.stripe.webhook',
        path: '/stripe/webhook',
        method: 'POST'
    }
];
